<template>
    <main class="register-login">
        <Header :text="headerText" />
        <div class="container">
            <section class="section register-form">
        <div class="ingreso">
            <div v-if="'not_found' == this.company.status">
            <p>La compañía que busca no esta recibiendo usuarios secundarios.</p><br/>
            <p>Por favor contacte a CFOremoto si cree que esto es un error.</p></div>
            <div v-if="'expired' == this.company.status">
            <p>Ya expiró este link para generar usuarios para la compañia</p><br/>
            <p style="text-align:center;">{{ this.company.company_name }}</p><br/>
            <p style="text-align:center;">{{ identifierLabel }} {{ this.company.company_rut }}</p><br/>
            <p>Por favor contacte a CFOremoto si cree que esto es un error.</p></div>
            <div class="card py-4" v-if="!['not_found', 'expired'].includes(this.company.status)">
                <div class="card-header-title is-size-3 pt-2 has-text-primary">
                </div>
                <div class="card-content">
                    <ValidationObserver
                        ref="observer"
                        v-slot="{ handleSubmit }"
                    >
                                            <div class="columns">
                            <div class="column is-12-mobile is-half">
                                <label
                                    class="label has-text-weight-bold company-placeholder"
                                    for="empresa"
                                >
                                    Nombre de la Empresa
                                </label>
                                <label
                                    class="label has-text-weight-bold company-placeholder"
                                    for="empresa"
                                >
                                {{ company.company_name }}
                                </label>
                            </div>
                            <div class="column is-12-mobile is-half">
                                <label
                                    class="label has-text-weight-bold company-placeholder"
                                    for="rut"
                                >
                                    {{ identifierLabel }} de la empresa
                                </label>
                                <label
                                    class="label has-text-weight-bold company-placeholder"
                                    for="empresa"
                                >
                                {{ company.company_rut }}
                                </label>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-12-mobile is-half">
                                <label
                                    class="label has-text-weight-bold"
                                    for="name"
                                >
                                    Nombre
                                </label>
                                <Input
                                    type="text"
                                    placeholder=""
                                    name="nombre"
                                    ref="first_name"
                                    v-model="user.first_name"
                                    rules="required|min:1|max:49"
                                    :disabled="company.status != 'found'"
                                />
                            </div>
                            <div class="column is-12-mobile is-half">
                                <label
                                    class="label has-text-weight-bold"
                                    for="apellido"
                                >
                                    Apellido
                                </label>
                                <Input
                                    type="text"
                                    placeholder=""
                                    name="apellido"
                                    ref="last_name"
                                    v-model="user.last_name"
                                    rules="required|min:1|max:99"
                                    :disabled="company.status != 'found'"
                                />
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-12-mobile is-half">
                                <label
                                    class="label has-text-weight-bold"
                                    for="email"
                                >
                                    Email
                                </label>
                                <Input
                                    type="text"
                                    placeholder="correo@ejemplo.cl"
                                    autocomplete="username"
                                    name="email"
                                    ref="email"
                                    v-model="user.email"
                                    rules="required|email|max:250"
                                    :disabled="company.status != 'found'"
                                />
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-12-mobile is-half">
                                <label
                                    class="label has-text-weight-bold"
                                    for="password"
                                >
                                    Clave
                                </label>
                                <Input
                                    rules="required|password_length"
                                    type="password"
                                    ref="password"
                                    name="password"
                                    minlength="4"
                                    maxlength="64"
                                    vid="password"
                                    v-model="user.password"
                                    autocomplete="current-password"
                                    :is-password="true"
                                    :safe-password="true"
                                    :disabled="company.status != 'found'"
                                />
                            </div>
                            <div class="column is-12-mobile is-half">
                                <label
                                    class="label has-text-weight-bold"
                                    for="password"
                                >
                                    Repetir Clave
                                </label>
                                <Input
                                    rules="required|confirmed:password"
                                    name="password"
                                    type="password"
                                    v-model="password_confirmation"
                                    :is-password="true"
                                    :disabled="company.status != 'found'"
                                />
                            </div>
                        </div>
                        <div class="is-block has-text-left mt-6 mb-6">
                            <CheckBox
                                :rules="{ required: { allowFalse: false } }"
                            >
                                <b-checkbox v-model="checkTerms">
                                    Acepto los
                                    <a
                                        :href="
                                            `http://${publicPath}/pdf/Politicas_Privacidad_CFO_App.pdf`
                                        "
                                        download
                                        target="_blank"
                                    >
                                        Términos y Condiciones
                                    </a>
                                </b-checkbox>
                            </CheckBox>
                        </div>
                        <button
                            id="continuar_button"
                            class="button is-fullwidth is-primary mb-3 mt-2"
                            :disabled="loading"
                            v-on:click.prevent="handleSubmit(submitForm)"
                        >
                            Crear un usuario para {{ company.company_name }}
                        </button>
                    </ValidationObserver>
                </div>
            </div>
            <p class="my-6 is-size-7">
                ¿Ya posees una cuenta?
                <a
                    class="ml-2 has-text-weight-semibold"
                    v-on:click.prevent="$router.push('/')"
                >
                    Ingresa aquí
                </a>
            </p>
        </div>
    </section>
        </div>
    </main>
</template>

<script>
import CheckBox from "@/components/inputs/CheckBox";
import Input from "@/components/inputs/Input";
import { ValidationObserver } from "vee-validate";
import { setSession } from "@/utils/auth";
import SegmentAnalytics from "@/utils/segmentAnalytics";
import { consoleHandlerError } from "@/utils/message";
import Header from "@/components/signupAndLogin/Header";
import { mapActions, mapMutations } from "vuex";

export default {
    name: "RegisterAnother",
      components: {
        Input,
        CheckBox,
        Header,
        ValidationObserver,
    },
    data() {
      return {
        uuid: null,
        company: { 'company_name': ' ', 'company_rut': ' ', 'status': 'waiting', 'is_foreign': false},
        password_confirmation: "",
        checkTerms: false,
        loading: false,
        rutMask: ["#.###.###-B", "##.###.###-B"],
        publicPath: window.location.hostname,
        user: {
          first_name: "",
          last_name: "",
          email: "",
          username: "",
          company_name: "",
          company_rut: "",
          company_uuid: "",
          password: "",
        },
      }
    },
    async created() {
      this.uuid = this.$route.params.uuid;
      try {
        this.company = await this.fetchCompanyFromUUID(this.$route.params.uuid);
      } catch(err) {
        this.company.status = 'not_found';
      }
    },
    methods: {
        ...mapMutations("userAuth", ["SET_LOGIN"]),
        ...mapActions("userAuth", ["fetchCompanyFromUUID", "registerUser"]),
        submitForm() {
            if (this.loading) {
                return;
            }
            // Disable the button by setting loading to true
            this.loading = true;
            this.user.username = this.user.email;
            this.user.client_type = 'SECONDARY';
            this.user.company_rut = this.company.company_rut;
            this.user.company_name = this.company.company_name;
            // Informativo: con company_uuid el backend resuelve el universo
            // desde la BD igual (el flag del request no manda).
            this.user.is_foreign = this.company.is_foreign === true;
            this.user.company_uuid = this.uuid;

            this.registerUser(this.user)
                .then((user) => {
                    setSession(user);
                    this.SET_LOGIN(user);
                    new SegmentAnalytics(user).trackRegisterFast();
                    this.$router.push("/dashboard");
                })
                .catch((error) => {
                    this.loading = false;
                    consoleHandlerError({
                        error,
                        refFields: this.$refs,
                    });
                });
        },
    },
    computed: {
      // Una extranjera no tiene RUT chileno: se rotula genérico.
      identifierLabel() {
        return this.company.is_foreign ? "Identificador" : "RUT";
      },
      headerText() {
        switch (this.company.status.toLowerCase()) {
          case 'waiting':
            return "Por favor espere mientras se buscan los datos de su compañía";
          case 'found':
            return 'Usted esta registrando un usuario para la compañia ' +
            this.company.company_name + ' ' + this.identifierLabel.toLowerCase() +
            ' ' + this.company.company_rut + '.'
          case 'not_found': 
          case 'expired':
          default:
            return '';
        }
      },
    }
};
</script>
<style scoped>
#continuar_button {
    white-space: normal;
    text-align: center;
    line-height: 1.5;
    padding-top: 8%;
    padding-bottom: 8%;
}
#continuar_button:disabled {
    background-color: #c0c0c0;
    color: #a0a0a0;
    cursor: not-allowed;
}
.register-form {
  padding-top: 0;
}
.card-header-title {
    display: none;
}
.card {
    padding-top: none;
}
.company-placeholder {
    height: 2em;
}
</style>
